import type { ActivationFlowModel } from './ActivationFlow.types'

export const initialActivationFlowState: ActivationFlowModel = {
  token: '',
  status: 'loading',
  setup: {
    password: '',
    confirmPassword: '',
    passwordTouched: false,
    confirmPasswordTouched: false,
    passwordDirty: false,
    confirmPasswordDirty: false,
    formSubmitted: false,
    submitState: 'idle',
    error: '',
  },
  recovery: {
    email: '',
    emailTouched: false,
    submitAttempted: false,
    submitState: 'idle',
    success: false,
    feedback: '',
    feedbackTone: 'error',
  },
}
